import Fetch from '../apiConfig/apiConfig';
import { AxiosPromise } from 'axios';
import { IOrderEdnResponse } from './IOrderEdnResponse';

export const getEdnDetails = (orderID: string, retailer: string): AxiosPromise<IOrderEdnResponse> => {
  return Fetch().then(axios => axios.get(`orders/edns?retailer=${retailer}&order=${orderID}`));
};
